.section {
  box-sizing: border-box;
  margin: var(--section-margin) auto;
  max-width: var(--container);
  padding: 0 1rem;
  width: 100%;
}

.card {
  background: #fff;
  box-shadow: var(--shadow-close);
}

.petrol {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

@media (min-width: 768px) {
  .section {
    padding-left: 0;
    padding-right: 0;
  }
}

/* After the 768px rule, so the card padding stays. */
.section.card,
.section.petrol {
  border-radius: 16px;
  padding: var(--spacing-l);
}

/* Only inside the 12-column grid of the desktop layout; elsewhere a section is one column. */
@media (min-width: 1000px) {
  .span4 {
    grid-column: span 4;
  }

  .span8 {
    grid-column: span 8;
  }
}
